import jobListBinding from './bind'

jobListBinding()
